﻿import api from '../api';
import { Resposta } from './Resposta';

export interface Item {
  respostaDescricao: string;
  contemComentario: boolean;
  itemPaiDescricao: string | undefined;
  dependenteId: string;
  perfilAcessoId: string;
  visivel: boolean;
  id: string;
  descricao: string;
  descricaoHtml: string;
  perfilResponsavel: string;
  sempreVisivel: boolean;
  editavel: boolean;
  excluivel: boolean;
  respostas: Resposta[];
  dependente: string;
  comentario: string;
  revisao: string;
  clausulaId: string;
  perfilAcessoNome: string;
  ordem: number;
  codigoStatus: number;
}

export interface Comentario {
  id: string;
  mensagem: string;
  mrn: boolean;
  nomeDoUsuario: string;
  nomeDoArquivo: string;
  possuiArquivo: boolean;
  dataHoraInclusao: string;
}

export interface Itenslist {
  itens: Item[];
}

export interface ItemChagemBool {
  id: string;
  valor: boolean;
}

export interface ClausulaIdPorStatus {
  clausulaId: string;
  stausCodigo: number[];
}

export interface PerfilAcessoClausulaId {
  perfilAcessoId: string;
  itemId: string;
}

export interface ItemDependente {
  itemDependenteId: string;
  itemId: string;
}

export interface ItemPai {
  itemPaiId: string;
  itemId: string;
}

export interface RespostaChange {
  itemId: string;
  respostasId: string[];
}

export interface ItemOrdem {
  ordem: number;
  itemId: string;
}

export const DeleteItem = (id: string) => api.delete(`itens/${id}`);
export const UpdateItem = (values: any) => api.put('itens/putItem', values);
export const putAtualizarDescricaoItem = (values: Item) => api.put('itens/putAtualizarDescricaoItem', values);
export const getAllItemByClausulaId = (clausulaId: string) =>
  api.get<Item[]>(`itens/getAllItemByClausulaId/${clausulaId}`);
export const getAllItemByClausulaIdFilter = (clausulaId: string) =>
  api.get<Item[]>(`itens/getAllItemByClausulaIdFilter/${clausulaId}`);
export const ObterComentarioPorItemId = (id: any) => api.get<Comentario[]>(`itens/obterComentarioPorItemId/${id}`);

export const DownloadAnexoLinhaItem = (id: any) => {
  const urlBase = window.location.origin;
  api.get<string>(`Medicao/ObterNomeFileAnexoArquivoLinhaItem/${id}`).then(nomeDoArquivo => {
    const fileName = nomeDoArquivo != null ? nomeDoArquivo : '';

    Axios.get(urlBase + `/api/Medicao/GetBlobDownloadAnexoArquivoLinhaMedicao?id=${id}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      link.setAttribute('id', 'downloadElementLinhaAnexoMedicao');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadElementLinhaAnexoMedicao').outerHTML = '';
    });
  });
};

export const SalvarComentario = (form: any) =>
  api.post('itens/updateComentarioItem', form, { disableNotification: 'true' });

export const UpdateManyItens = (values: Itenslist) => {
  return api.put(`itens/updateManyItens`, values);
};

export const UpdateManyItensAprovacao = (values: Itenslist) => {
  return api.put(`itens/updateManyItensAprovacao`, values);
};

export const updateSempreVisivel = (values: ItemChagemBool) => {
  return api.put(`itens/updateSempreVisivel`, values);
};

export const updateNaoEditavel = (values: ItemChagemBool) => {
  return api.put(`itens/updateNaoEditavel`, values);
};

export const updateNaoExcluir = (values: ItemChagemBool) => {
  return api.put(`itens/updateNaoExcluir`, values);
};

export const updatePerfilRespostanvel = (values: PerfilAcessoClausulaId) => {
  return api.put(`itens/updatePerfilRespostanvel`, values);
};

export const updateItemDependente = (values: ItemDependente) => {
  return api.put(`itens/updateItemDependente`, values);
};

export const getAllItemByClausulaIdPorStatus = (form: ClausulaIdPorStatus) =>
  api.get<Item[]>(
    `itens/getAllItemByClausulaIdPorStatus/${form.clausulaId}?statusCodigos=${form.stausCodigo.join(',')}`,
  );

export const getItemById = (itemId: string) => api.get<Item>(`itens/getItemById/${itemId}`);

export const updateItemPai = (values: ItemPai) => {
  return api.put(`itens/updateItemPai`, values);
};

export const updateItemRespostas = (values: RespostaChange) => {
  return api.put(`itens/updateItemRespostas`, values);
};

export const UpdateItemOrdem = (values: any) => {
  return api.put(`itens/updateItemOrdem`, values);
};

export const cancelarAprovacaoDoItem = (values: any) => api.put<Item>('itens/cancelarAprovacaoDoItem', values);
